export {getButtonOutlineWhite} from '@hconnect/common/styles'

export const getHighlightedEventSx = (selected?: boolean) => ({
  backgroundColor: selected ? 'rgba(218, 9, 1, 0.12)' : 'rgba(218, 9, 1, 0.04)',
  borderLeftStyle: 'solid',
  borderLeftWidth: 4,
  borderLeftColor: 'error.light',
  '&:hover': {
    backgroundColor: 'rgba(218, 9, 1, 0.08)'
  }
})
